import { type MCPServerInfo } from '../../types';

const TeradataServer: MCPServerInfo = {
  serverId: 'TERADATA',
  name: 'Teradata',
  slug: 'teradata',
  description:
    'MCP server for Teradata databases. Query, analyze, and manage data with RAG tools, feature store, data quality, DBA tools, and vector store capabilities.',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => ({
  command: 'uvx',
  args: ['teradata-mcp-server@latest'],
  env: config?.databaseUri ? { DATABASE_URI: config.databaseUri } : {}
})`
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: ['databaseUri'],
    properties: {
      databaseUri: {
        type: 'string',
        description:
          'Teradata connection URI (e.g., teradata://USERNAME:PASSWORD@HOST:1025/DATABASE)',
        sensitive: true
      }
    }
  },
  installConfig: {
    required: ['databaseUri'],
    properties: {
      databaseUri: {
        type: 'string',
        description:
          'Teradata connection URI (e.g., teradata://USERNAME:PASSWORD@HOST:1025/DATABASE)',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default TeradataServer;
